export interface InquiryAttachment {
  id: number;
  filename: string;
  mimetype: string;
}

export interface InquiryChild {
  id: number;
  body: string;
  summary: string;
  user_id: number;
  attachments: InquiryAttachment[];
  created_at: Date;
  login?: string;
  name?: string;
}

export const InquiryCategory = ['お問い合わせ', '出金依頼', '振替依頼', '新規出資依頼' /*, '訂正依頼' */] as const;
export const InquiryPriority = ['通常', '優先', '緊急'] as const;

export const InquiryStatus = ['受付', '確認中', '対応中', '回答済', '完了'] as const;
export const CorrectionStatus = ['受付', '確認中', '対応中', '処理済', '完了', '取消'] as const;
export const WithdrawalStatus = ['受付', '確認中', '対応中', '出金額確定', '出金済', '完了', '取消'] as const;
export const TransferStatus = ['受付', '確認中', '対応中', '入金待ち', '振替確定', '処理済', '完了', '取消'] as const;
export const InvestStatus = ['受付', '確認中', '対応中', '入金待ち', '入金確認', '処理済', '完了', '取消'] as const;

export const InquiryStatusMap = {
  'お問い合わせ': InquiryStatus,
  '訂正依頼': CorrectionStatus,
  '出金依頼': WithdrawalStatus,
  '振替依頼': TransferStatus,
  '新規出資依頼': InvestStatus,
};

export interface Inquiry {
  id: number;
  user_id: number;
  title: string;
  remark: string;

  category: typeof InquiryCategory[number];
  sub_category: string;
  status: typeof InquiryStatus[number] | typeof WithdrawalStatus[number] | typeof CorrectionStatus[number];
  priority: typeof InquiryPriority[number];

  admin_user_id: number;
  children: InquiryChild[];
  login?: string;
  name?: string;
  email?: string;

  withdrawal_transaction?: any;
  first_child? : InquiryChild;

  first_child_summary?: string;
  created_at: Date;
  updated_at: Date;
}

export const ActivePoolTypes = [
  'CHFX',
  'BB',
  'EF',
  'HF',
  'UF',
  'AX',
  'GBPX',
  'PE',
  'SP',
  'ST',
];

export const ActiveCurrencies = [
  'JPY',
  'USD'
];

